module.exports = __webpack_public_path__ + "img/topic4-1.6f8b6f67.png";